import { render } from "./CitiesView.vue?vue&type=template&id=4c9b31f8"
import script from "./CitiesView.vue?vue&type=script&lang=js"
export * from "./CitiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__